// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"b9b4e513","172":"e4b7b2a6","361":"6e719510","488":"d7411027","568":"413afd7e","673":"6ad91348","845":"0ca02ecb"}[chunkId] + ".chunk.js";
};